'use strict'

import React,{Component} from 'react';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

export default class IssueMenu extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).report.menu;

    var reports=this.props.reports; //{id: uuid.v4(),date:new Date()}];
    return (
      <div style={{display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
        <div style={{paddingTop:15}}>
          <b>{labels.issueOptions}</b>
          <div style={{paddingLeft:10}}>
            <div style={{cursor: "pointer", textDecoration: "underline"}} onClick={this.props.createReport}>{labels.createIssueReport}</div>
          </div>
          <div style={{paddingLeft:10}}>
            <div style={{cursor: "pointer", textDecoration: "underline"}} onClick={this.props.createExceptionReport}>{labels.createExceptionReport}</div>
          </div>
        </div>
        <div style={{paddingTop:15}}>
          <b>{labels.issueReports}</b>
          <div style={{paddingLeft:10}}>
            {reports!==undefined && reports.length>0 ? (
              reports.map(report=>(
                <div key={report.id}>
                  {this.props.selected===report.id ? (
                    <b>{new Date(report.date).toISOString().substring(0,10)}</b>
                  ) : (
                    <a href={"change/issues/"+this.props.id+"/reports/"+report.id}>{new Date(report.date).toISOString().substring(0,10)}</a>
                  )}
                  {report.exception ? (
                    <img style={{paddingLeft:5, height: "10pt"}} src="/images/Flag_DarkGrey_22x16.gif"/>
                  ) : null}
                </div>
              ))
            ) : (
              <i>{labels.noReports}</i>
            )}
          </div>
        </div>

        <div style={{marginTop:30,backgroundColor:"#f7f7f7", padding:10}}>
         <b>{labels.whenToUseReports}</b><br/><br/>
         {labels.whenToUseReportsIngress} <br/><br/>
         {labels.whenToUseIssueReport} <br/><br/>
         {labels.whenToUseExceptionReport}
        </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./views/change/IssueMenu.jsx